// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

const CategoryName = ({ category, currentPage }: Props) => {
    if (!category) {
        return null;
    }

    const isSearchCrawler = getIsWebCrawler();

    // XNG-Change
    return (
        <Typography
            variant={currentPage.type === "CategoryDetailsPage" ? "h1" : "h2"}
            data-test-selector={`categoryName_${category.shortDescription ?? category.name}`}
        >
            {category.shortDescription ?? category.name}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
